import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { ComponentPropsWithoutRef, forwardRef } from "react";
import { styled } from "~/application/theme";
import { contentStyle } from "./contentStyle";

export type DropdownMenuSubContentProps = ComponentPropsWithoutRef<
  typeof DropdownMenuPrimitive.SubContent
>;

const SubContentRoot = styled(DropdownMenuPrimitive.SubContent, {
  ...contentStyle,
});

export const DropdownMenuSubContent = forwardRef<HTMLDivElement, DropdownMenuSubContentProps>(
  (props, ref) => (
    <DropdownMenuPrimitive.Portal>
      <SubContentRoot {...props} ref={ref} />
    </DropdownMenuPrimitive.Portal>
  )
);

DropdownMenuSubContent.displayName = "DropdownMenuSubContent";
